/**
 * Page | Home
 * Home page module for the root route
 */

import { PageBase, page } from "@sygnal/sse-core";
import { gsap } from "gsap";

@page('/home')
export class HomePage extends PageBase {

  protected onPrepare(): void {}

  protected async onLoad(): Promise<void> {
    this.animateBlobs();
  }

  private animateBlobs(): void {
    gsap.to('.blob_right', {
      rotation: 15,
      duration: 8,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
    });

    gsap.to('.blob_left', {
      rotation: -15,
      duration: 10,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
    });
  }
}
